import { useQuery } from "react-query";
import { isEmpty } from "../../lib/helpers/helpers";
import { viewAllCart, viewSelectedWeddingCart } from "../actions/cart";

export const useFetchCartItems = ({ email }) => {
	return useQuery(["All_Cart", { email }], () => viewAllCart({ email }), {
		enabled: !isEmpty(email),
	});
};

export const useFetchSelectedCartItems = ({ email, weddingId }) => {
	return useQuery(
		["Selected_Cart", { email, weddingId }],
		() => viewSelectedWeddingCart({ email, weddingId }),
		{
			enabled: !isEmpty(email) && !isEmpty(weddingId),
		}
	);
};

// export const usePostAction = () => {
// 	return useMutation(reactToWeddingPost);
// };
